import { render, staticRenderFns } from "./MdtSortBy.vue?vue&type=template&id=93dfea9a&scoped=true"
import script from "./MdtSortBy.vue?vue&type=script&lang=js"
export * from "./MdtSortBy.vue?vue&type=script&lang=js"
import style0 from "./MdtSortBy.vue?vue&type=style&index=0&id=93dfea9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93dfea9a",
  null
  
)

export default component.exports